import React, { useState } from 'react';
import Select from 'react-select';

// Sized to sit alongside the Reports cardStyles.select native selects.
const selectStyles = {
  container: (base) => ({ ...base, marginBottom: 10 }),
  control: (base) => ({
    ...base,
    borderColor: 'gray',
    borderRadius: 5,
    minHeight: 32,
    fontSize: 13,
  }),
  valueContainer: (base) => ({ ...base, padding: '0 5px' }),
  placeholder: (base) => ({ ...base, color: '#333' }),
  dropdownIndicator: (base) => ({ ...base, padding: 2 }),
  clearIndicator: (base) => ({ ...base, padding: 2 }),
  indicatorSeparator: () => ({ display: 'none' }),
  menu: (base) => ({ ...base, fontSize: 13 }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

const SearchableSelect = ({
  placeholder,
  options = [],
  value,
  onChange,
  isClearable = true,
  searchHint = true,
  ariaLabel,
  isMulti = false,
}) => {
  const [focused, setFocused] = useState(false);

  const matches = candidate => options.find(
    option => String(option.value) === String(candidate)
  ) || null;

  // Multi mode keeps `value` as raw values rather than react-select's option
  // objects, so a caller can hand it straight to filterNames.
  const selected = isMulti ?
    (value || []).map(matches).filter(Boolean) :
    matches(value);

  const handleChange = option => {
    if (isMulti) {
      onChange((option || []).map(item => item.value));
    } else {
      onChange(option ? option.value : '');
    }
  };
  const focusedPlaceholder =
    searchHint ? `${placeholder} — or type to search` : placeholder;

  return (
    <Select
      classNamePrefix="searchable-select"
      aria-label={ariaLabel}
      placeholder={focused ? focusedPlaceholder : placeholder}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      options={options}
      value={selected}
      onChange={handleChange}
      isMulti={isMulti}
      isClearable={isClearable}
      styles={selectStyles}
      menuPortalTarget={document.body}
    />
  );
};

export default SearchableSelect;
